var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_488",
    "data-name": "Rechteck 488",
    width: 22.275,
    height: 22.93,
    fill: "#415056"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Key-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Key-icon",
    clipPath: "url(#clip-Key-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3392",
    "data-name": "Gruppe 3392",
    transform: "translate(1.001 1.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_827",
    "data-name": "Pfad 827",
    d: "M865.8-77.541c-.686-.1-1.374-.18-2.057-.3a18.71,18.71,0,0,1-8.78-3.972,18.5,18.5,0,0,1-6.533-10.025,18.755,18.755,0,0,1,4.728-18.419,17.2,17.2,0,0,1,9.619-5.093,18.917,18.917,0,0,1,17.861,5.657,18.439,18.439,0,0,1,5,9.88c.121.68.2,1.367.3,2.051v2.686c-.024.107-.052.213-.07.321-.179,1.062-.275,2.145-.548,3.182a18.071,18.071,0,0,1-6.53,10.082,18.743,18.743,0,0,1-8.4,3.657c-.657.11-1.318.193-1.978.289Zm19.086-19.1a18.075,18.075,0,0,0-18.03-18.046,18.072,18.072,0,0,0-18.054,18.021,18.065,18.065,0,0,0,18.012,18.06A18.07,18.07,0,0,0,884.889-96.646Z",
    transform: "translate(-847.74 115.514)",
    fill: "#415056"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3394",
    "data-name": "Gruppe 3394",
    transform: "translate(7.999 7.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3393",
    "data-name": "Gruppe 3393",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_837",
    "data-name": "Pfad 837",
    d: "M7.351,17.705c0,.682,0,1.313,0,1.945,0,.485-.125.607-.621.608-.63,0-1.261,0-1.932,0,0,.423,0,.818,0,1.212,0,.275,0,.55,0,.826-.007.364-.127.5-.5.512q-1.909.071-3.819.121c-.334.009-.49-.151-.48-.489.035-1.284.07-2.567.132-3.85A.847.847,0,0,1,.4,18.106q4.1-4.117,8.215-8.216a.524.524,0,0,0,.154-.648,6.949,6.949,0,1,1,7.639,4.6,6.553,6.553,0,0,1-2.52-.075.4.4,0,0,0-.427.13c-.338.353-.677.708-1.041,1.033a.872.872,0,0,1-.507.208c-.65.024-1.3.01-2,.01v.829c0,.408.005.816,0,1.223a.447.447,0,0,1-.511.5c-.571.006-1.141,0-1.712,0H7.351m1.7-.856c0-.689,0-1.339,0-1.989,0-.425.142-.567.568-.569.673,0,1.345.007,2.017-.008a.608.608,0,0,0,.367-.153c.343-.318.685-.643.994-.994a.793.793,0,0,1,.893-.254A6.091,6.091,0,1,0,9.691,9.3c.2.482.193.524-.165.883q-4.171,4.173-8.337,8.351a.83.83,0,0,0-.221.5c-.05.926-.07,1.853-.1,2.78,0,.078.01.156.018.26l3.054-.1v-.337q0-.734,0-1.468c0-.686.074-.762.745-.762H6.495c0-.7,0-1.35,0-2,0-.4.148-.549.555-.551.651,0,1.3,0,2,0",
    transform: "translate(0 0)",
    fill: "#415056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_838",
    "data-name": "Pfad 838",
    d: "M190.064,41a1.837,1.837,0,1,1,1.837-1.837A1.84,1.84,0,0,1,190.064,41m0-3.185a1.347,1.347,0,1,0,1.347,1.347,1.349,1.349,0,0,0-1.347-1.347",
    transform: "translate(-172.854 -34.281)",
    fill: "#415056"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon_key.a0bb7a5711c52bae2138093abe29122d.svg";
export { ForwardRef as ReactComponent };